import { useEffect, useState } from "react";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";
import {
  CardContent,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Switch,
} from "@mui/material";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialSelect from "../../../../components/MasterSelect";
import { fetchData } from "../../../../services";
import { useLocation } from "react-router-dom";
import { useSnackbar } from "../../../../context/popup";
import { useLoading } from "../../../../components/Loading";
import DropDownConfig from "../../../Utils/DropDownConfig";

export const MotorModelForm = ({ onsubmit, viewData }) => {

  const location = useLocation();
  const isEdit = location.pathname.includes("/edit-model");
  const { setCircleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();

  const [modelData, setModelData] = useState({
    // model information
    name: "",
    vehicleCategory: null,
    motorMake: null,
    iplVehicleCategoryId: "",
    iplVehicleCategoryName: "",
    motorMakeId: "",
    motorMakeName: "",
    isActive: true,

    // model information status
    nameStatus: "unchecked",
    vehicleCategoryStatus: "unchecked",
    motorMakeStatus: "unchecked",
  });
  
  const [motorMakeOptions, setMotorMakeOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);

  //dropdown apis
  useEffect(() => {
    //dropdown apis for form
    const fetchDropdowns = async () => {
      setCircleLoading(true);
      try {
        const [makeResponse, categoryResponse] = await Promise.all([
          fetchData(`/reference/motor/mmv/makes?dropdown=true&isActive=true`),
          fetchData(
            `/reference/general/key-value-store?dropdown=true&code=${DropDownConfig?.motorCategory}`
          ), //code passing for category
        ]);

        if (makeResponse?.success) {
          setMotorMakeOptions(
            makeResponse.data?.items?.map((item) => ({
              value: item.id,
              label: item.name,
            })) || []
          );
        }

        if (categoryResponse?.success) {
          setCategoryOptions(
            categoryResponse.data?.items?.map((item) => ({
              value: item.id,
              label: item.keyName,
            })) || []
          );
        }
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
        showSnackbar("Error fetching All dropdowns","warning");
      } finally {
        setCircleLoading(false);
      }
    };

    fetchDropdowns();
  }, []);

  useEffect(() => {
    if (!isEdit) {
      return;
    }
    if(viewData){
      setModelData(viewData);
    }
  }, [viewData]);

  const handleModelDataChange = (event, selectEvent) => {
    let modelState = { ...modelData };

    const changeAllowed = true;

    if (event?.target === undefined && selectEvent) {
      switch (selectEvent.name) {
        case "vehicleCategory":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              modelState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";

              modelState["iplVehicleCategoryId"] = event?.value;
              modelState["iplVehicleCategoryName"] = event?.label;
            } else {
              modelState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "motorMake":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              modelState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";

              modelState["motorMakeId"] = event?.value;
              modelState["motorMakeName"] = event?.label;
            } else {
              modelState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      modelState[selectEvent.name] = event;
    } else if (event) {
      switch (event.target.name) {
        case "name":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{2,20})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              modelState[event.target.name + "Status"] = "success";
            } else {
              modelState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        modelState[event.target.name] = event.target.value;
      }
    }
    setModelData(modelState);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      modelData.nameStatus === "success" &&
      modelData.vehicleCategoryStatus === "success" &&
      modelData.motorMakeStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleSubmit = () => {
    if (checkAllFields()) {
      onsubmit(modelData);
    }
  };

  return (
    <>
      <div>
        <CardContent sx={{ minHeight: "50vh" }}>
          <MaterialBox>
            <Grid container spacing={1}>
              <Grid size={{ xs: 12, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Model Name*
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="name"
                  placeholder="eg. Model Name"
                  value={modelData.name}
                  onChange={handleModelDataChange}
                  error={modelData.nameStatus === "error" ? true : false}
                  success={modelData.nameStatus === "success" ? true : false}
                />
                {modelData.nameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Name should be maximum 20 characters long and can
                      contain only alphabets
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>

              <Grid size={{ xs: 12, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Category*
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="vehicleCategory"
                  value={modelData.vehicleCategory}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleModelDataChange} //selectedValue, event
                  options={categoryOptions?.map((value) => {
                    return {
                      value: value.value,
                      label: value.label,
                    };
                  })}
                  error={
                    modelData.vehicleCategoryStatus === "error" ? true : false
                  }
                  success={
                    modelData.vehicleCategoryStatus === "success"
                      ? true
                      : false
                  }
                  isClearable
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Motor Make*
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="motorMake"
                  value={modelData.motorMake}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleModelDataChange} //selectedValue, event
                  options={motorMakeOptions?.map((value) => {
                    return {
                      value: value.value,
                      label: value.label,
                    };
                  })}
                  error={modelData.motorMakeStatus === "error" ? true : false}
                  success={
                    modelData.motorMakeStatus === "success" ? true : false
                  }
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Actve
                  </MaterialTypography>
                </MaterialBox>
                <MaterialBox>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={modelData.isActive}
                        onChange={(e) =>
                          handleModelDataChange({
                            target: {
                              name: "isActive",
                              value: e.target.checked,
                            },
                          })
                        }
                        color="primary"
                      />
                    }
                    label={
                      <MaterialTypography variant="caption" fontWeight="bold">
                        {modelData.isActive ? "Active" : "Inactive"}
                      </MaterialTypography>
                    }
                    sx={{ marginLeft: 0 }}
                  />
                </MaterialBox>
              </Grid>
            </Grid>
          </MaterialBox>
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <MaterialButton
            sx={{ m: 2 }}
            variant="outlined"
            color="dark"
            onClick={() => {
              window.history.back();
            }}
          >
            Cancel
          </MaterialButton>
          <MaterialButton
            sx={{ m: 2 }}
            variant="gradient"
            color="dark"
            disabled={!checkAllFields()}
            onClick={handleSubmit}
          >
            {isEdit ? "Update" : "Submit"}
          </MaterialButton>
        </MaterialBox>
      </div>
    </>
  );
};
